<template>
  <el-row
    class="receipt-review"
    v-if="oneReviewButtonIsEnabled"
  >
    <el-col
      v-if="googleReview"
      :span="tripAdviser && !customReview ? 11 : 24"
      :xs="24"
    >
      <el-link
        :underline="false"
        class="review-button"
        @click="trackEvent('Google', transactionInfo.googlereviewUrl)"
      >
        <img
          src="@/assets/img/social/google.svg"
          alt="Google Reviews"
          width="36px"
        >
        Google Review
      </el-link>
    </el-col>
    <el-col
      v-if="tripAdviser"
      :span="googleReview && !customReview ? 11 : 24"
      :offset="tripAdviser && !customReview ? 2 : 0"
      :xs="{ span: 24, offset: 0 }"
    >
      <el-link
        :underline="false"
        :href="transactionInfo.tripadvisorUrl"
        class="review-button"
      >
        <img
          src="@/assets/img/tripadvisor.png"
          alt="Trip Advisor Reviews"
          width="40px"
        >
        Trip Advisor Review
      </el-link>
    </el-col>
    <el-col v-if="customReview">
      <el-link
        :underline="false"
        :href="qrCode.businessEntity.feedbackUrl"
        class="review-button"
      >
        <img
          v-if="qrCode.businessEntity.feedbackLogoBase64"
          :src="qrCode.businessEntity.feedbackLogoBase64"
          :alt="qrCode.businessEntity.feedbackLabel"
          width="30"
        >
        {{ qrCode.businessEntity.feedbackLabel }}
      </el-link>
    </el-col>
  </el-row>
</template>

<script>
import reviewsMixin from '../reviews-mixin';
export default {
  name: "ReceiptReview",
  mixins: [reviewsMixin],
  props: {
    qrCode: {
      type: Object,
      default: () => {},
    },
    transactionInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    trackEvent(service, link = '') {
      this.$amplitude.logEvent(`${service} Review button clicked`, {
        qrCode: this.transactionInfo.payment?.qrCode ?? 0,
      });

      window.open(link, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
.receipt-review {
  .review {
    &-button::v-deep {
      min-height: 48px;
      width: 100%;
      border: 1px solid #000000;
      border-radius: 10px;
      margin-bottom: 10px;

      span {
        display: flex;
        align-items: center;

        img {
          margin-right: 10px;
        }
      }
    }

    &-title {
      color: #2d2e2f;
      font-size: 20px;
      line-height: 20px;
      font-family: "Raleway Bold", serif;
      text-align: center;
    }
  }
}
</style>
